/* eslint-disable */

import { useState } from "react";
import { IconButton } from "@mui/material";
import { Alert } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const NewBanner = () => {
  const [open, setOpen] = useState(true);

  if (!open) return null;

  return (
    <Alert
      severity="info"
      action={
        <IconButton aria-label="close" color="inherit" size="small" onClick={() => setOpen(false)}>
          <CloseIcon fontSize="inherit" />
        </IconButton>
      }
      sx={{
        position: "absolute",
        top: "20px",
        left: "50%",
        transform: "translateX(-50%)",
        zIndex: 9999,
        width: "50%",
      }}
    >
      The portal has been updated to the latest version. Please note that not all old data has been
      transferred to the new version. If you notice any missing data or files, feel free to contact
      us at: <b>support@motcos.com</b>
    </Alert>
  );
};

export default NewBanner;

const styles = {
  bannerContainer: {
    position: "absolute",
    border: "1px solid red",
  },
};
